import RL from './route-literals';

export default {
  fallbackForUnauthenticated: `/${RL.signIn}`,
  fallbackForAuthenticated: `/${RL.dashboard}/${RL.home}`, // this URL should be accessible irrespective of permissions
  root: RL.root,
  signIn: `/${RL.signIn}`,
  signUp: `/${RL.signUp}`,
  ssoCallback: `/${RL.sso}/${RL.callback}`,
  dashboard: `/${RL.dashboard}`,
  home: `/${RL.dashboard}/${RL.home}`,
  activity: `/${RL.dashboard}/${RL.activity}`,
  ebgNotifications: `/${RL.dashboard}/${RL.ebgNotifications}`,
  ebgNotificationsPending: `/${RL.dashboard}/${RL.ebgNotifications}/${RL.pending}`,
  ebgNotificationsReviewed: `/${RL.dashboard}/${RL.ebgNotifications}/${RL.reviewed}`,
  ebgNotificationsArchive: `/${RL.dashboard}/${RL.ebgNotifications}/${RL.archive}`,
  account: `/${RL.account}`,
  provisions: `/${RL.provisions}`,
  provisionsSignatures: `/${RL.provisions}/${RL.signatures}`,
  provisionsStamps: `/${RL.provisions}/${RL.stamps}`,
  provisionsInvitations: `/${RL.provisions}/${RL.invitations}`,
  provisionsDocuments: `/${RL.provisions}/${RL.documents}`,
  documents: `/${RL.documents}`,
  documentsAll: `/${RL.documents}/${RL.all}`,
  documentsSent: `/${RL.documents}/${RL.sent}`,
  documentsReceived: `/${RL.documents}/${RL.received}`,
  documentsProcessing: `/${RL.documents}/${RL.processing}`,
  documentsCCd: `/${RL.documents}/${RL.cc}`,
  documentsDrafts: `/${RL.documents}/${RL.drafts}`,
  documentsActionRequired: `/${RL.documents}/${RL.actionRequired}`,
  documentsWaitingForOthers: `/${RL.documents}/${RL.waitingForOthers}`,
  documentsExpiringSoon: `/${RL.documents}/${RL.expiringSoon}`,
  documentsFailed: `/${RL.documents}/${RL.failed}`,
  documentsNeslErrors: `/${RL.documents}/${RL.neslFailureCases}`,
  documentsExpired: `/${RL.documents}/${RL.expired}`,
  documentsCompleted: `/${RL.documents}/${RL.completed}`,
  documentsRejected: `/${RL.documents}/${RL.rejected}`,
  documentDetails: `/${RL.document}/${RL.details}`,
  bulkSigning: `/${RL.bulkSigning}`,
  bulkSigningList: `/${RL.bulkSigning}/${RL.list}`,
  bulkSigningDetails: `/${RL.bulkSigning}/${RL.details}`,
  documentFolders: `/${RL.documents}/${RL.folder}`,
  dashboardTemplates: `/${RL.dashboard}/${RL.templates}`,
  dashboardTemplatesV3: `/${RL.dashboard}/${RL.templates}/${RL.v3}`,
  dashboardTemplatesV4: `/${RL.dashboard}/${RL.templates}/${RL.v4}`,
  dashboardTemplatesV4Published: `/${RL.dashboard}/${RL.templates}/${RL.v4}/${RL.published}`,
  dashboardTemplatesV4Drafts: `/${RL.dashboard}/${RL.templates}/${RL.v4}/${RL.drafts}`,
  dashboardContacts: `/${RL.dashboard}/${RL.contacts}`,
  dashboardWorkflows: `/${RL.dashboard}/${RL.workflows}`,
  dashboardWorkflowsV4: `/${RL.dashboard}/${RL.workflows}/${RL.v4}`,
  dashboardWorkflowsV3: `/${RL.dashboard}/${RL.workflows}/${RL.v3}`,
  dashboardWorkflowDetails: `/${RL.dashboard}/${RL.workflows}/${RL.colonId}/${RL.details}`,
  dashboardWorkflowV4Details: `/${RL.dashboard}/${RL.workflows}/${RL.v4}/${RL.colonId}/${RL.details}`,
  stamps: `/${RL.stamps}`,
  groups: `/${RL.groups}`,
  stampSeries: `/${RL.stamps}/${RL.series}`,
  stampGroups: `/${RL.stamps}/${RL.groups}`,
  stampSeriesAll: `/${RL.stamps}/${RL.series}/${RL.all}`,
  stampSeriesFavourites: `/${RL.stamps}/${RL.series}/${RL.favourites}`,
  stampSeriesDraft: `/${RL.stamps}/${RL.series}/${RL.drafts}`,
  stampGroupAll: `/${RL.stamps}/${RL.groups}/${RL.all}`,
  stampGroupFavourites: `/${RL.stamps}/${RL.groups}/${RL.favourites}`,
  settings: `/${RL.accounts}/${RL.settings}`,
  accounts: `/${RL.accounts}`,
  wallet: `/${RL.accounts}/${RL.wallet}`,
  department: `/${RL.accounts}/${RL.department}`,
  admin: `/${RL.accounts}/${RL.admin}`,
  notifications: `/${RL.accounts}/${RL.settings}/${RL.notifications}`,
  profile: `/${RL.accounts}/${RL.settings}/${RL.profile}`,
  api: `/${RL.accounts}/${RL.settings}/${RL.api}`,
  esignAndSeal: `/${RL.accounts}/${RL.settings}/${RL.esignAndSeal}`,
  settingsDocument: `/${RL.accounts}/${RL.settings}/${RL.documents}`,
  automation: `/${RL.accounts}/${RL.automation}`,
  purchase: `/${RL.accounts}/${RL.wallet}/${RL.purchase}`,
  purchaseHistory: `/${RL.accounts}/${RL.wallet}/${RL.purchaseHistory}`,
  purchaseHistoryEsign: `/${RL.accounts}/${RL.wallet}/${RL.purchaseHistory}/${RL.esign}`,
  purchaseHistoryStamp: `/${RL.accounts}/${RL.wallet}/${RL.purchaseHistory}/${RL.stamp}`,
  invoices: `/${RL.accounts}/${RL.wallet}/${RL.invoices}`,
  taxInvoices: `/${RL.accounts}/${RL.wallet}/${RL.invoices}/${RL.taxInvoices}`,
  proformaInvoices: `/${RL.accounts}/${RL.wallet}/${RL.invoices}/${RL.proformaInvoices}`,
  consumptionHistory: `/${RL.accounts}/${RL.wallet}/${RL.consumptionHistory}`,
  consumptionHistoryEsign: `/${RL.accounts}/${RL.wallet}/${RL.consumptionHistory}/${RL.esign}`,
  consumptionHistoryStamp: `/${RL.accounts}/${RL.wallet}/${RL.consumptionHistory}/${RL.stamp}`,
  billingProfiles: `/${RL.accounts}/${RL.wallet}/${RL.billingProfiles}`,
  lowBalanceConfigs: `/${RL.accounts}/${RL.wallet}/${RL.lowBalanceConfigs}`,
  branding: `/${RL.accounts}/${RL.department}/${RL.branding}`,
  security: `/${RL.accounts}/${RL.department}/${RL.security}`,
  eSignature: `/${RL.accounts}/${RL.department}/${RL.eSignature}`,
  stamp: `/${RL.accounts}/${RL.department}/${RL.stamp}`,
  documentConfigs: `/${RL.accounts}/${RL.department}/${RL.documentConfigs}`,
  inviteeConfigs: `/${RL.accounts}/${RL.department}/${RL.inviteeConfigs}`,
  neslEsignConfig: `/${RL.accounts}/${RL.department}/${RL.neslEsignConfig}`,
  sftp: `/${RL.accounts}/${RL.department}/${RL.sftp}`,
  users: `/${RL.accounts}/${RL.admin}/${RL.users}`,
  newUsers: `/${RL.accounts}/${RL.admin}/${RL.newUsers}`,
  departments: `/${RL.accounts}/${RL.admin}/${RL.departments}`,
  termsConditions: `/${RL.termsConditions}`,
  privacyPolicy: `/${RL.privacyPolicy}`,
  seriesDetails: `/${RL.stamps}/${RL.series}/${RL.colonId}/${RL.details}`,
  seriesStamps: `/${RL.stamps}/${RL.series}/${RL.colonId}/${RL.stamps}`,
  seriesPurchases: `/${RL.stamps}/${RL.series}/${RL.colonId}/${RL.purchases}`,
  pdfEditor: `/${RL.pdfEditor}`,
  pdfEditorAddFields: `/${RL.pdfEditor}/${RL.addFields}/${RL.colonId}`,
  pdfEditorViewFields: `/${RL.pdfEditor}/${RL.viewFields}/${RL.colonId}`,
  previewPdf: `/${RL.pdfEditor}/${RL.previewPdf}`,
  pdfEditorV4AddFields: `/${RL.pdfEditor}/${RL.v4}/${RL.addFields}`,
  pdfEditorV4AddFieldsWithId: `/${RL.pdfEditor}/${RL.v4}/${RL.addFields}/${RL.colonId}`,
  pdfEditorV4ViewFieldsWithId: `/${RL.pdfEditor}/${RL.v4}/${RL.viewFields}/${RL.colonId}`,
  pdfEditorV4PreviewPdf: `/${RL.pdfEditor}/${RL.v4}/${RL.previewPdf}`,
  documentOpen: (id) => `/${RL.document}/${id}`, // TODO: @Tapesh - should not be a function
  paymentCollect: `/${RL.accounts}/${RL.department}/${RL.paymentCollect}`,
  workflowBuilderConfig: `/${RL.accounts}/${RL.department}/${RL.workflowBuilderConfig}`,
  integrationConfigs: `/${RL.accounts}/${RL.department}/${RL.integrationConfigs}`,
  departmentNeslProfiles: `/${RL.accounts}/${RL.department}/${RL.neslEsignConfig}/${RL.neslProfiles}`,
  departmentNeslEbgEventReviewers: `/${RL.accounts}/${RL.department}/${RL.neslEsignConfig}/${RL.eventReviewers}`,
  workflowRun: `/${RL.workflow}/${RL.run}`,
  createDocumentV4: `/${RL.document}/${RL.v4}/${RL.create}`,
  workflowCreate: `/${RL.workflow}/${RL.v4}/${RL.create}`,
  workflowDraftEdit: `/${RL.workflow}/${RL.v4}/${RL.draft}/${RL.edit}`,
  editTemplate: `/${RL.dt}/${RL.v4}/${RL.edit}`,
  customFields: `/${RL.dashboard}/${RL.customFields}`,
  dashboardReports: `/${RL.dashboard}/${RL.reports}`,
};
